import { Button } from '@advanza/ui'
import NiceModal from '@ebay/nice-modal-react'
import FreeTrialCancelModal from 'components/providers/FreeTrialCancelModal'

interface Props {
    onCancel: () => Promise<void>
}

const FreeTrialCancelButton = ({ onCancel }: Props) => {
    return (
        <Button
            onClick={() => NiceModal.show(FreeTrialCancelModal, { onConfirm: onCancel })}
            name="text">
            Cancel the free trial
        </Button>
    )
}

export default FreeTrialCancelButton
